import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DashboardJobsType, IDashboardJob, useGetDashboardJobInfo } from '~/domain/DashboardJobs';
import { CANCEL_JOB_ACTION } from '../../../../../actions';
import { createSuccessSelector } from '../../../../../api/selectors';
import history from '../../../../../history';
import { headerPendingTabTitles } from '../../utils';
import { CustomTable } from '../CustomTable';
import { ExpirationUpdatePopup } from './ExpirationUpdatePopup';
import { renderRow } from './renderRow';

const successActions = [CANCEL_JOB_ACTION];
const successSelector = createSuccessSelector(successActions);

export const PendingTabLegacy = () => {
  const { refetch } = useGetDashboardJobInfo();
  const removedSuccessfully = useSelector((state) => successSelector(state));

  const handleOnClick = (item: IDashboardJob) => {
    const counters = item?.multipleCounters ?? [];
    const favoriteCandidate = counters.find((counter) => !!counter.isFavorite);

    // display the favorite candidate if exists, otherwise use the first candidate
    const candidateId = (favoriteCandidate ?? counters?.[0])?.candidate?.id;
    const shiftId = item?.id;

    if (candidateId && shiftId) {
      history.push(`/dashboard/job/${item?.id}/confirm/${candidateId}`);
    }
  };

  useEffect(() => {
    if (removedSuccessfully) {
      refetch();
    }
  }, [removedSuccessfully, refetch]);

  return (
    <>
      <CustomTable
        type={DashboardJobsType.ACTION_REQUIRED}
        renderRow={(item) => renderRow({ item, handleOnClick })}
        headerTitles={headerPendingTabTitles}
        onRowClick={(item) => handleOnClick(item)}
        dataCy="action-needed-table"
        rowDataCy="pending-shift-row"
      />

      <ExpirationUpdatePopup />
    </>
  );
};
